<modal
  [id]="id"
  [header]="(isEditMode() ? 'v2.orgSettings.webhooks.editWebhookTitle' : 'v2.orgSettings.webhooks.createNewWebhook') | translate"
  [headerIcon]="isEditMode() ? editIcon : plusIcon"
  [widthClass]="'tw-w-11/12 lg:tw-w-[576px]'"
  [heightClass]="'tw-h-auto tw-max-h-[90vh]'"
  [showFooterDivider]="false"
  [closeButtonEnabled]="!isSubmitting()"
  [enableBackdropClose]="!isSubmitting()"
  [escapeToClose]="!isSubmitting()"
  (onCloseModal)="handleModalClose()"
>
  <div slot="body" class="tw-flex tw-flex-col -tw-mb-4">
    @if (isEditMode()) {
    <select-input
      class="tw-w-full"
      [control]="form.controls.event_id"
      [label]="'v2.orgSettings.webhooks.event' | translate"
      [placeholder]="'v2.orgSettings.webhooks.event' | translate"
      key="name"
      valueName="id"
      [values]="eventOptions()"
      [minSelections]="1"
      [maxSelections]="1"
      [isDropdown]="true"
      [basicSelect]="true"
      [isBasicDropdownValue]="true"
      [enableSearch]="true"
      [isCountryField]="false"
      [isSingleSelect]="true"
      [clear]="false"
      [id]="'webhook_event_id'"
      [required]="true"
    ></select-input>
    } @else {
    <select-input
      class="tw-w-full"
      [control]="form.controls.event_ids"
      [label]="'v2.orgSettings.webhooks.event' | translate"
      [placeholder]="'v2.orgSettings.webhooks.event' | translate"
      key="name"
      [valueName]="'id'"
      [values]="events"
      [minSelections]="1"
      [maxSelections]="999"
      [isDropdown]="true"
      [basicSelect]="true"
      [enableSearch]="true"
      [isCountryField]="false"
      [isSingleSelect]="false"
      [clear]="true"
      [id]="'webhook_event_ids'"
      [required]="true"
    ></select-input>
    }

    <basic-input
      [control]="form.controls.name"
      [label]="'v2.orgSettings.webhooks.webhookName' | translate"
      [placeholder]="'v2.orgSettings.webhooks.webhookName' | translate"
      [required]="true"
      [allowClearButton]="false"
    ></basic-input>

    <basic-input
      [control]="form.controls.webhook_url"
      [fieldType]="BasicFieldType.URL"
      [label]="'v2.orgSettings.webhooks.webhookUrl' | translate"
      [placeholder]="'v2.orgSettings.webhooks.webhookUrl' | translate"
      [required]="true"
      [allowClearButton]="false"
    ></basic-input>

    <select-input
      class="tw-w-full"
      [control]="form.controls.triggers"
      [label]="'v2.orgSettings.webhooks.triggers' | translate"
      [placeholder]="'v2.orgSettings.webhooks.triggers' | translate"
      key="name"
      [valueName]="'id'"
      [values]="webhookTriggers"
      [minSelections]="1"
      [maxSelections]="webhookTriggers.length"
      [isDropdown]="true"
      [basicSelect]="true"
      [enableSearch]="true"
      [isCountryField]="false"
      [isSingleSelect]="false"
      [clear]="true"
      [id]="'webhook_triggers'"
      [required]="true"
    ></select-input>

    <div class="tw-flex tw-flex-col">
      <div class="tw-relative">
        <basic-input
          class=""
          [control]="form.controls.signing_secret_encrypted"
          [label]="'v2.orgSettings.webhooks.securityString' | translate"
          [placeholder]="'v2.orgSettings.webhooks.securityString' | translate"
          [allowClearButton]="false"
        ></basic-input>
        <span
          class="tw-pointer-events-auto tw-absolute tw-end-3 tw-top-[35px] tw-z-10 tw-flex tw-h-4 tw-w-4 -tw-translate-y-1/2 tw-cursor-pointer tw-items-center tw-justify-center tw-text-gray-500"
          [ngxTippy]="securityStringTooltip"
          [tippyProps]="securityStringTippyProps"
          (mousedown)="$event.preventDefault(); $event.stopPropagation()"
          (click)="$event.stopPropagation()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="tw-w-4 tw-h-4" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path
              d="M8 14.6666C11.6819 14.6666 14.6667 11.6819 14.6667 7.99998C14.6667 4.31808 11.6819 1.33331 8 1.33331C4.3181 1.33331 1.33333 4.31808 1.33333 7.99998C1.33333 11.6819 4.3181 14.6666 8 14.6666Z"
              stroke="currentColor"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M8 10.6666V8" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8 5.33331H8.00667" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
      </div>
    </div>
  </div>

  <div slot="footer" class="tw-w-full tw-px-6 tw-pb-6">
    <button
      type="button"
      class="tw-w-full tw-rounded-lg tw-bg-blue-600 tw-font-inter tw-text-sm lg:tw-text-base tw-font-medium tw-text-white hover:tw-bg-blue-700 disabled:tw-bg-blue-300 disabled:tw-pointer-events-none tw-py-2.5 lg:tw-py-3.5 tw-transition-colors"
      [disabled]="isSaveDisabled()"
      [buttonSpinner]="isSubmitting()"
      (click)="onSave()"
    >
      {{ 'v2.orgSettings.webhooks.save' | translate }}
    </button>
  </div>
</modal>
